export default "__VITE_ASSET__9e68dade__"